'use client';
/* eslint-disable */
import { useState, useRef } from 'react';
import {
   Box,
   Button,
   Flex,
   IconButton,
   Text,
   useColorModeValue,
   useDisclosure,
   Select,
   Switch,
   Grid,
   useOutsideClick,
   useBreakpointValue,
   useColorMode,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   SimpleGrid,
   ModalFooter,
   Spinner,
   Center,
} from '@chakra-ui/react';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import {
   createColumnHelper,
   flexRender,
   getCoreRowModel,
   getSortedRowModel,
   useReactTable,
} from '@tanstack/react-table';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import React, { useEffect } from 'react';
import Card from 'components/card/Card';
import Menu from 'components/menu/MainMenu';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import AddEditForm from './AddEditForm';
import ViewSingleData from '../../components/ViewSingleData';
import { useDispatch, useSelector } from 'react-redux';
import {
   addAccount,
   deleteCustomer,
   getAccount,
   getAccountForCashBank,
   getAccountForMaster,
   multiDeleteCustomer,
   updateStatus,
} from '../../../../../redux/actions/account';
import { getSingleCustomer } from '../../../../../redux/actions/customer';
import { useUser } from '../../../../../contexts';
import DeleteDialog from '../../components/DeleteDialog';
import filter from 'assets/img/nfts/filter.svg';
import filter1 from 'assets/img/nfts/filter1.svg';
import { GridItem, Input, FormLabel } from '@chakra-ui/react';
import nodata from 'assets/img/nfts/no data.svg';
import { ACCOUNT_TYPE } from '../../../../../constants/index';
import { MdNavigateNext, MdNavigateBefore } from 'react-icons/md';
import { SearchIcon } from '@chakra-ui/icons';
import { motion } from 'framer-motion';
import { Import, Plus, X } from 'lucide-react';
import DynamicTable from '../../components/DynamicAllDataTable';
import MobileDataTable from '../../components/MobileDataTable';
import { getFinancialYearDates } from 'utils/util';
import { getReportLedger, getReportOutstandingDetail } from '../../../../../redux/actions/reports';
import { getSingleVendors } from '../../../../../redux/actions/vendor';
import { useGlobal } from '../../../../../contexts';
import { BsEye } from 'react-icons/bs';
import { postColumnsHideShow } from '../../../../../redux/actions/utility';
import Loader from 'views/admin/default/Loader';

const columnHelper = createColumnHelper();
const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

export default function Customers() {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const [sorting, setSorting] = React.useState([]);
   const dispatch = useDispatch();
   const userData = useSelector((state) => state?.account?.listForMaster || []);
   const glgroup = useSelector((state) => state.glGroup?.list || []);
   const pagination = useSelector((state) => state.account?.paginationForMaster);
   const [data, setData] = useState([]);
   const [currentRow, setCurrentRow] = React.useState({});
   const isAbs = currentRow?.isAbs === 'true' || currentRow?.isAbs === true;
   const singleEntity = useSelector((state) => state?.vendor?.single || {});
   const OS = useSelector((state) => state.reports.outstanding || []);
   const { user } = useUser();
   const Admin = user?.isAdmin;
   const isMobileOrTablet = useBreakpointValue({ base: true, md: false, lg: false });
   const [focusedInput, setFocusedInput] = React.useState(null);
   const [pageSize, setPageSize] = React.useState(10);
   const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
   const [selectedRowId, setSelectedRowId] = React.useState(null);
   const [searchQuery, setSearchQuery] = React.useState('');
   const [debouncedSearchQuery, setDebouncedSearchQuery] = React.useState('');
   const [isOpenSingleView, setIsOpenSingleView] = React.useState(null);
   const companyId = Number(localStorage.getItem('companyId'));
   const customerRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.customer
      : null;
   const isDesktop = useBreakpointValue({ base: false, md: true });
   const [isEditingPage, setIsEditingPage] = useState(false);
   const [pageInputValue, setPageInputValue] = useState('');
   const [currentPage, setCurrentPage] = useState(1);
   const [limit, setLimit] = useState(10);
   const { globalFromDate, globalToDate } = getFinancialYearDates();
   const Ledger = useSelector((state) => state.reports.ledger || []);

   // ✅ ADD LOADING STATES
   const [isLoading, setIsLoading] = useState(false);
   const [isSearching, setIsSearching] = useState(false);
   const [isPageChanging, setIsPageChanging] = useState(false);

   const [columnsData, setColumnsData] = React.useState([
      {
         id: 'name',
         header: 'NAME',
         accessor: 'name',
         index: 0,
      },
      {
         id: 'address',
         header: 'ADDRESS',
         accessor: (row) => {
            const billingAddress = row.accountaddress.find((addr) => addr.name === 'billing');
            return billingAddress ? billingAddress.address1 : '';
         },
         index: 1,
      },
      {
         id: 'city',
         header: 'CITY',
         accessor: (row) => {
            const billingAddress = row.accountaddress.find((addr) => addr.name === 'billing');
            return billingAddress ? billingAddress.city : '';
         },
         index: 2,
      },
      {
         id: 'state',
         header: 'STATE',
         accessor: (row) => {
            const billingAddress = row.accountaddress.find((addr) => addr.name === 'billing');
            return billingAddress ? billingAddress.state : '';
         },
         index: 3,
      },
      {
         id: 'country',
         header: 'COUNTRY',
         accessor: (row) => {
            const billingAddress = row.accountaddress.find((addr) => addr.name === 'billing');
            return billingAddress ? billingAddress.country : '';
         },
         index: 4,
      },
      {
         id: 'pincode',
         header: 'PINCODE',
         accessor: (row) => {
            const billingAddress = row.accountaddress.find((addr) => addr.name === 'billing');
            return billingAddress ? billingAddress.pincode : '';
         },
         index: 5,
      },
      {
         id: 'mobile',
         header: 'MOBILE',
         accessor: 'mobile',
         index: 6,
      },
      {
         id: 'panNo',
         header: 'PAN',
         accessor: 'panNo',
         index: 7,
      },
      {
         id: 'email',
         header: 'EMAIL',
         accessor: 'email',
         index: 8,
      },
      {
         id: 'gstRegNo',
         header: 'GST',
         accessor: 'gstRegNo',
         index: 9,
      },
      {
         id: 'createdAt',
         header: 'CREATED DATE',
         accessor: 'createdAt',
         index: 10,
      },
      {
         id: 'ledger',
         header: 'LEDGER',
         accessor: 'ledger',
         index: 11,
      },
      {
         id: 'amt',
         header: 'BALANCE',
         accessor: 'amt',
         index: 12,
      },
      {
         id: 'status',
         header: 'STATUS',
         accessor: 'status',
         cell: (info) => {
            return <div style={{ paddingBottom: 28, paddingTop: 24 }}>{info.getValue()}</div>;
         },
         index: 13,
      },
   ]);

   const [columnVisibility, setColumnVisibility] = React.useState({
      name: true,
      address: false,
      city: false,
      state: false,
      country: false,
      pincode: false,
      mobile: true,
      panNo: false,
      email: false,
      gstRegNo: true,
      createdAt: false,
      glgroupname: true,
      amt: true,
      status: true,
   });

   const [isColumnModalOpen, setIsColumnModalOpen] = useState(false);

   // Filter states
   const [selectedFilter, setSelectedFilter] = useState('');
   const [nameselectedfilter, setnameselectedfilter] = useState('');
   const [addressSelectedFilter, setAddressSelectedFilter] = useState('');
   const [citySelectedFilter, setCitySelectedFilter] = useState('');
   const [stateSelectedFilter, setStateSelectedFilter] = useState('');
   const [countrySelectedFilter, setCountrySelectedFilter] = useState('');
   const [pincodeSelectedFilter, setPincodeSelectedFilter] = useState('');
   const [mobileselectedfilter, setmobileselectedfilter] = useState('');
   const [panselectedfilter, setpanselectedfilter] = useState('');
   const [emailSelectedFilter, setEmailSelectedFilter] = useState('');
   const [gstSelectedFilter, setGstSelectedFilter] = useState('');
   const [ledgerSelectedFilter, setLedgerSelectedFilter] = useState('');
   const [balanceSelectedFilter, setBalanceSelectedFilter] = useState('');
   const [createdDateSelectedFilter, setcreatedDateSelectedFilter] = useState('');

   const [inputValue, setInputValue] = useState('');
   const [nameinputvalue, setnameinputvalue] = useState('');
   const [addressinputvalue, setaddressinputvalue] = useState('');
   const [cityinputvalue, setcityinputvalue] = useState('');
   const [stateinputvalue, setstateinputvalue] = useState('');
   const [countryinputvalue, setcountryinputvalue] = useState('');
   const [pincodeinputvalue, setpincodeinputvalue] = useState('');
   const [mobileinputvalue, setmobileinputvalue] = useState('');
   const [paninputvalue, setpaninputvalue] = useState('');
   const [emailinputvalue, setemailinputvalue] = useState('');
   const [gstinputvalue, setgstinputvalue] = useState('');
   const [createddateinputvalue, setcreateddateinputvalue] = useState('');
   const [ledgerinputvalue, setledgerinputvalue] = useState('');
   const [balanceinputvalue, setbalanceinputvalue] = useState('');
   const [statusinputvalue, setstatusinputvalue] = useState('');
   const [addedName, setAddedName] = useState('');

   const [accountData, setAccountData] = useState([]);
   const singleEntityWithLedger = {
      ...singleEntity,
      ledger: Ledger,
      os: OS,
   };

   const { userGlobalSettingsData } = useGlobal();
   const globalSetting = userGlobalSettingsData?.[0]?.askCompany?.account;
   const shouldShowCompanyDropdown = globalSetting || false;

   useEffect(() => {
      if (user?.viewJson) {
         const companySettings = user.viewJson.find((item) => item.companyId === companyId);
         if (companySettings?.account) {
            setColumnVisibility((prev) => {
               const newVisibility = companySettings.account;
               return JSON.stringify(prev) === JSON.stringify(newVisibility) ? prev : newVisibility;
            });
         }
      }
   }, [user, companyId, user?.viewJson]);

   // ✅ MODIFIED: Fetch data with loading state
   useEffect(() => {
      const fetchData = async () => {
         try {
            setIsLoading(true); // Start loading

            let fetchParams = {
               compId: user?.loginhistory?.companyId,
               type: ACCOUNT_TYPE.CUSTOMER,
               page: currentPage,
               search: debouncedSearchQuery,
               sortBy: sorting.length ? sorting[0]?.name : 'name',
               sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
               ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
            };

            let filters = [];

            if (nameinputvalue && nameselectedfilter) {
               filters.push({ name: 'acc.name', value: nameinputvalue, type: nameselectedfilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }

            if (addressinputvalue && addressSelectedFilter) {
               filters.push({ name: 'ac.address1', value: addressinputvalue, type: addressSelectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }

            if (cityinputvalue && citySelectedFilter) {
               filters.push({ name: 'ci.name', value: cityinputvalue, type: citySelectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }

            if (stateinputvalue && stateSelectedFilter) {
               filters.push({ name: 'st.name', value: stateinputvalue, type: stateSelectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }

            if (countryinputvalue && countrySelectedFilter) {
               filters.push({ name: 'co.name', value: countryinputvalue, type: countrySelectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }

            if (pincodeinputvalue && pincodeSelectedFilter) {
               filters.push({ name: 'ac.pincode', value: pincodeinputvalue, type: pincodeSelectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }

            if (mobileinputvalue && mobileselectedfilter) {
               filters.push({ name: 'ac.mobile', value: mobileinputvalue, type: mobileselectedfilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }

            if (paninputvalue && panselectedfilter) {
               filters.push({ name: 'acc.pan', value: paninputvalue, type: panselectedfilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }

            if (emailinputvalue && emailSelectedFilter) {
               filters.push({ name: 'ac.email', value: emailinputvalue, type: emailSelectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }

            if (gstinputvalue && gstSelectedFilter) {
               filters.push({ name: 'ac.gst', value: gstinputvalue, type: gstSelectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }

            if (createddateinputvalue && createdDateSelectedFilter) {
               filters.push({ name: 'acc.createdAt', value: createddateinputvalue, type: createdDateSelectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }

            if (ledgerinputvalue && ledgerSelectedFilter) {
               filters.push({ name: 'gl.name', value: ledgerinputvalue, type: ledgerSelectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }

            if (balanceinputvalue && balanceSelectedFilter) {
               filters.push({ balance: { value: balanceinputvalue, type: balanceSelectedFilter } });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }

            if (createddateinputvalue) {
               fetchParams.country = createddateinputvalue;
            }
            setIsLoading(true);
            const response = await dispatch(getAccountForMaster(fetchParams));
            setIsLoading(false);

            if (response?.length > 0 && Array.isArray(response)) {
               setAccountData(response);
            } else {
               console.warn('No data found. Setting empty array.');
               setAccountData([]);
            }
         } catch (error) {
            console.error('Error fetching data:', error);
            setAccountData([]);
         } finally {
            setIsLoading(false); // Stop loading
         }
      };
      fetchData();
   }, [
      dispatch,
      nameselectedfilter,
      gstSelectedFilter,
      panselectedfilter,
      citySelectedFilter,
      stateSelectedFilter,
      countrySelectedFilter,
      ledgerSelectedFilter,
      balanceSelectedFilter,
      createddateinputvalue,
      ledgerinputvalue,
      balanceinputvalue,
      nameinputvalue,
      gstinputvalue,
      paninputvalue,
      cityinputvalue,
      stateinputvalue,
      countryinputvalue,
      pincodeinputvalue,
      mobileinputvalue,
      emailinputvalue,
   ]);

   useEffect(() => {
      if (!limit) {
         setData([...userData]);
      } else {
         if (userData.length <= limit) {
            setData([...userData]);
         }
      }
   }, [userData]);

   useEffect(() => {
      if (Array.isArray(Ledger) && Ledger.length > 0) {
         setData((prevData) => [...prevData, ...Ledger]);
      }
   }, [Ledger]);

   const debounce = (func, delay) => {
      let timer;
      return function (...args) {
         clearTimeout(timer);
         timer = setTimeout(() => func.apply(this, args), delay);
      };
   };

   // ✅ MODIFIED: Debounced search with loading state
   const debouncedSearchHandler = React.useCallback(
      debounce((query) => {
         setDebouncedSearchQuery(query);
         setIsSearching(false); // Stop searching loader after debounce
      }, 500),
      [],
   );

   // ✅ MODIFIED: Handle search with loading state
   const handleSearchChange = (e) => {
      const value = e.target.value;
      setSearchQuery(value);
      setIsSearching(true); // Start searching loader
      debouncedSearchHandler(value);
   };

   useEffect(() => {
      setCurrentPage(1);
   }, [searchQuery]);

   // ✅ MODIFIED: Main data fetch with loading states
   useEffect(() => {
      const fetchMainData = async () => {
         try {
            setIsLoading(true);
            await dispatch(
               getAccountForMaster({
                  type: ACCOUNT_TYPE.CUSTOMER,
                  page: currentPage,
                  search: debouncedSearchQuery,
                  sortBy: sorting.length ? sorting[0]?.name : 'name',
                  sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
                  compId: user?.loginhistory?.companyId,
                  ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
               }),
            );
         } catch (error) {
            console.error('Error fetching main data:', error);
         } finally {
            setIsLoading(false);
            setIsPageChanging(false); // Reset page changing loader
         }
      };

      fetchMainData();
   }, [debouncedSearchQuery, currentPage, limit, sorting]);

   // ✅ MODIFIED: Page change with loading state
   const handlePageChange = (directionOrPage) => {
      setIsPageChanging(true); // Start page changing loader

      if (typeof directionOrPage === 'number') {
         setCurrentPage(directionOrPage);
      } else {
         const newPage = directionOrPage === 'next' ? pagination.nextPage : pagination.previousPage;
         if (newPage) setCurrentPage(newPage);
      }
   };

   const handlePageClick = () => {
      setIsEditingPage(true);
      setPageInputValue('');
   };

   const handlePageInputSubmit = () => {
      const page = parseInt(pageInputValue);
      if (!isNaN(page) && page >= 1 && page <= pagination?.totalPages) {
         handlePageChange(page);
      }
      setIsEditingPage(false);
      setPageInputValue('');
   };

   const handlePageInputBlur = () => {
      handlePageInputSubmit();
   };

   const handlePageKeyDown = (e) => {
      if (e.key === 'Enter') {
         handlePageInputSubmit();
      } else if (e.key === 'Escape') {
         setIsEditingPage(false);
         setPageInputValue('');
      }
   };

   const handlePageSizeChange = (e) => {
      const value = e.target.value;
      const newLimit = value === 'ALL' ? pagination?.totalProducts : Number(value);
      setLimit(newLimit);
      setCurrentPage(1);
   };

   const handleDelete = async () => {
      if (selectedRowId !== null) {
         try {
            await dispatch(deleteCustomer(selectedRowId, companyId));
            setData(data?.filter((row) => row.id !== selectedRowId));
            setDeleteDialogOpen(false);
            dispatch(
               getAccountForMaster({
                  type: ACCOUNT_TYPE.CUSTOMER,
                  page: currentPage,
                  search: debouncedSearchQuery,
                  sortBy: sorting.length ? sorting[0]?.name : 'name',
                  sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
                  compId: user?.loginhistory?.companyId,
                  ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
               }),
            );
            dispatch(
               getAccount({
                  type: ACCOUNT_TYPE.CUSTOMER,
                  page: currentPage,
                  sortBy: sorting.length ? sorting[0]?.name : 'name',
                  sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
                  compId: user?.loginhistory?.companyId,
                  ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
               }),
            );
         } catch (err) {
            console.error('Failed to delete:', err);
         }
      }
   };

   const handleDeleteClick = (id) => {
      setSelectedRowId(id);
      setDeleteDialogOpen(true);
   };

   const handleMutiDeleteClick = (ids) => {
      if (ids.length > 0) {
         const payload = {
            ids: ids.map(Number),
            compId: user?.loginhistory?.companyId.toString(),
         };
         dispatch(multiDeleteCustomer(JSON.stringify(payload)));
         setDeleteDialogOpen(false);
         dispatch(
            getAccountForMaster({
               type: ACCOUNT_TYPE.CUSTOMER,
               page: currentPage,
               search: debouncedSearchQuery,
               sortBy: sorting.length ? sorting[0]?.name : 'name',
               sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
               compId: user?.loginhistory?.companyId,
               ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
         dispatch(
            getAccount({
               type: ACCOUNT_TYPE.CUSTOMER,
               page: currentPage,
               sortBy: sorting.length ? sorting[0]?.name : 'name',
               sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
               compId: user?.loginhistory?.companyId,
               ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      }
   };

   const filteredData = React.useMemo(() => {
      if (!searchQuery) return data;
      return data?.filter((row) =>
         columnsData?.some((col) => String(row[col.id]).toLowerCase().includes(searchQuery.toLowerCase())),
      );
   }, [data, searchQuery, columnsData]);

   const handleFocus = (id) => setFocusedInput(id);
   const handleBlur = () => setFocusedInput(null);

   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
   const backgroundColor = useColorModeValue('white', 'rgba(12, 20, 41, 1)');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [isEditMode, setIsEditMode] = React.useState(false);

   const columns = columnsData
      .filter((column) => columnVisibility[column.id])
      .map((column) =>
         columnHelper.accessor(column.id, {
            id: column.id,
            header: () => (
               <Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }}>
                  {column.header}
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
      );

   const table = useReactTable({
      data,
      columns,
      state: { sorting },
      onSortingChange: setSorting,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   const ColumnVisibilityModal = ({ isOpen, onClose, columnVisibility, setColumnVisibility, user }) => {
      const [localVisibility, setLocalVisibility] = useState(columnVisibility);
      const companyId = Number(localStorage.getItem('companyId'));

      const { colorMode } = useColorMode();
      const isDark = colorMode === 'dark';

      useEffect(() => {
         setLocalVisibility(columnVisibility);
      }, [isOpen, columnVisibility]);

      useEffect(() => {
         const handleEscKey = (event) => {
            if (event.key === 'Escape' && isOpen) {
               onClose();
            }
         };

         document.addEventListener('keydown', handleEscKey);

         return () => {
            document.removeEventListener('keydown', handleEscKey);
         };
      }, [isOpen, onClose]);

      const handleSave = async () => {
         try {
            const updatedViewJson = user.viewJson
               ? user.viewJson.map((item) =>
                    item.companyId === companyId ? { ...item, account: localVisibility } : item,
                 )
               : [{ companyId, account: localVisibility }];

            await dispatch(
               postColumnsHideShow({
                  userId: user?.id,
                  viewJson: updatedViewJson,
               }),
            );

            setColumnVisibility(localVisibility);
            onClose();
         } catch (error) {
            console.error('Error saving column settings:', error);
         }
      };

      if (!isOpen) return null;

      return (
         <div className="fixed inset-0 z-[999] flex items-center justify-center p-4">
            <div
               className={`absolute inset-0 transition-colors duration-300 ${isDark ? 'bg-black/70' : 'bg-black/40'}`}
               onClick={onClose}
            />

            <div
               className={`relative w-full max-w-2xl transform transition-all duration-300 ${
                  isDark
                     ? 'bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900'
                     : 'bg-gradient-to-br from-white via-gray-50 to-white'
               } rounded-2xl shadow-2xl border ${
                  isDark ? 'border-slate-700/50' : 'border-gray-200/50'
               } overflow-hidden flex flex-col max-h-[80vh]`}>
               <div
                  className={`relative px-8 py-6 border-b flex-shrink-0 ${
                     isDark
                        ? 'border-slate-700/50 bg-gradient-to-r from-slate-800/50 to-slate-900/50'
                        : 'border-gray-200/50 bg-gradient-to-r from-gray-50/50 to-white/50'
                  }`}>
                  <h2 className={`text-2xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>Show/Hide Columns</h2>
                  <p className={`mt-1 text-sm ${isDark ? 'text-slate-400' : 'text-gray-600'}`}>
                     Customize which columns appear in your view
                  </p>
                  <button
                     onClick={onClose}
                     className={`absolute top-6 right-6 p-2 rounded-lg transition-all duration-200 ${
                        isDark
                           ? 'hover:bg-slate-700/50 text-slate-400 hover:text-white'
                           : 'hover:bg-gray-100 text-gray-500 hover:text-gray-900'
                     }`}>
                     <X className="w-5 h-5" />
                  </button>
               </div>

               <div className="flex-1 overflow-y-auto px-8 py-6">
                  <div className="grid grid-cols-2 gap-4">
                     {Object.entries(localVisibility).map(([key, value]) => (
                        <div
                           key={key}
                           className={`group relative p-3 rounded-xl transition-all duration-300 border-2 ${
                              value
                                 ? isDark
                                    ? 'bg-gradient-to-br from-blue-900/20 to-indigo-900/20 border-blue-500/50 shadow-lg shadow-blue-500/10'
                                    : 'bg-gradient-to-br from-blue-50/50 to-indigo-50/50 border-blue-400/50 shadow-lg shadow-blue-200/30'
                                 : isDark
                                 ? 'bg-slate-800/30 border-slate-700/30 hover:border-slate-600/50'
                                 : 'bg-white/50 border-gray-300/30 hover:border-gray-400/50'
                           } cursor-pointer hover:scale-[1.02]`}
                           onClick={() => setLocalVisibility((prev) => ({ ...prev, [key]: !prev[key] }))}>
                           <div className="flex items-center justify-between">
                              <label
                                 className={`font-semibold text-base cursor-pointer transition-colors duration-200 capitalize ${
                                    isDark ? 'text-white' : 'text-gray-900'
                                 }`}>
                                 {key
                                    .split(/(?=[A-Z])/)
                                    .join(' ')
                                    .toLowerCase()}
                              </label>

                              <div
                                 className={`relative inline-flex h-7 w-12 items-center rounded-full transition-all duration-300 ${
                                    value
                                       ? isDark
                                          ? 'bg-gradient-to-r from-blue-600 to-indigo-600 shadow-lg shadow-blue-500/30'
                                          : 'bg-gradient-to-r from-blue-500 to-indigo-500 shadow-lg shadow-blue-400/30'
                                       : isDark
                                       ? 'bg-slate-700'
                                       : 'bg-gray-300'
                                 }`}>
                                 <span
                                    className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform duration-300 shadow-md ${
                                       value ? 'translate-x-6' : 'translate-x-1'
                                    }`}
                                 />
                              </div>
                           </div>

                           <div
                              className={`mt-3 flex items-center gap-2 text-xs font-medium ${
                                 value
                                    ? isDark
                                       ? 'text-blue-400'
                                       : 'text-blue-600'
                                    : isDark
                                    ? 'text-slate-500'
                                    : 'text-gray-500'
                              }`}>
                              <div
                                 className={`h-1.5 w-1.5 rounded-full ${
                                    value
                                       ? isDark
                                          ? 'bg-blue-400 shadow-lg shadow-blue-400/50'
                                          : 'bg-blue-500 shadow-lg shadow-blue-400/50'
                                       : isDark
                                       ? 'bg-slate-600'
                                       : 'bg-gray-400'
                                 }`}
                              />
                              {value ? 'Visible' : 'Hidden'}
                           </div>
                        </div>
                     ))}
                  </div>
               </div>

               <div
                  className={`px-8 py-5 border-t flex justify-end gap-3 flex-shrink-0 ${
                     isDark
                        ? 'border-slate-700/50 bg-gradient-to-r from-slate-800/50 to-slate-900/50'
                        : 'border-gray-200/50 bg-gradient-to-r from-gray-50/50 to-white/50'
                  }`}>
                  <button
                     onClick={onClose}
                     className={`px-6 py-2.5 rounded-lg font-semibold transition-all duration-200 ${
                        isDark
                           ? 'text-slate-300 hover:bg-slate-700/50 hover:text-white'
                           : 'text-gray-700 hover:bg-gray-200 hover:text-gray-900'
                     }`}>
                     Cancel
                  </button>
                  <button
                     onClick={handleSave}
                     className={`px-6 py-2.5 rounded-lg font-semibold transition-all duration-200 shadow-lg ${
                        isDark
                           ? 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 text-white shadow-blue-500/30'
                           : 'bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white shadow-blue-400/30'
                     }`}>
                     Save
                  </button>
               </div>
            </div>
         </div>
      );
   };

   const handleSave = async (data) => {
      dispatch(
         getAccountForMaster({
            type: ACCOUNT_TYPE.CUSTOMER,
            page: currentPage,
            search: debouncedSearchQuery,
            sortBy: sorting.length ? sorting[0]?.name : 'name',
            sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
            compId: user?.loginhistory?.companyId,
            ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
         }),
      );
      await dispatch(
         getAccountForCashBank({
            compId: user?.loginhistory?.companyId,
            status: true,
            ...(shouldSendCompanyidAccount && { companyIds: user?.loginhistory?.companyId }),
         }),
      );
      dispatch(
         getAccount({
            page: currentPage,
            sortBy: sorting.length ? sorting[0]?.name : 'name',
            sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
            compId: user?.loginhistory?.companyId,
            ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
         }),
      );
   };

   const paginatedData = React.useMemo(() => {
      if (limit === pagination?.totalProducts) return userData;

      if (!Array.isArray(userData) || userData.length === 0) {
         return [];
      }
      return userData;
   }, [userData, pagination?.currentPage, limit, pagination?.totalProducts]);

   const totalPages = pageSize === filteredData?.length ? 1 : Math.ceil(filteredData.length / pageSize);

   const handleRefreshData = () => {
      dispatch(
         getAccountForMaster({
            type: ACCOUNT_TYPE.CUSTOMER,
            page: currentPage,
            search: debouncedSearchQuery,
            sortBy: 'name',
            sortOrder: 'desc',
            compId: user?.loginhistory?.companyId,
            ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
         }),
      );
   };

   const handleStatusUpdate = async (id, status) => {
      try {
         await dispatch(updateStatus({ id, status }));
         dispatch(
            getAccountForMaster({
               type: ACCOUNT_TYPE.CUSTOMER,
               page: currentPage,
               search: debouncedSearchQuery,
               sortBy: 'name',
               sortOrder: 'desc',
               compId: user?.loginhistory?.companyId,
               ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
         dispatch(
            getAccount({
               type: ACCOUNT_TYPE.CUSTOMER,
               page: currentPage,
               sortBy: 'name',
               sortOrder: 'desc',
               compId: user?.loginhistory?.companyId,
               ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      } catch (err) {
         console.error('Error updating status:', err);
      }
   };

   var dynamicArray = [];
   dynamicArray = [
      { label: 'Name', value: singleEntity.name || '-' },
      { label: 'Email', value: singleEntity.email || '-' },
      { label: 'Mobile', value: singleEntity.mobile || '-' },
      {
         label: 'Address',
         value: singleEntity.accountaddress?.[0]?.address1 || '-',
      },
      { label: 'GSTIN', value: singleEntity.gstRegNo || '-' },
      { label: 'City', value: singleEntity.accountaddress?.[0]?.city || '-' },
      { label: 'State', value: singleEntity.accountaddress?.[0]?.state || '-' },
      {
         label: 'Country',
         value: singleEntity.accountaddress?.[0]?.country || '-',
      },
      {
         label: 'Pincode',
         value: singleEntity.accountaddress?.[0]?.pincode || '-',
      },
   ];

   const handleDeleteEntity = (entityId) => {
      setIsOpenSingleView(false);
   };

   const handleViewSingleData = async (id) => {
      const accountbyid = {
         id: Number(id),
         compId: String(user?.loginhistory?.companyId),
      };
      const today = new Date().toISOString().split('T')[0];
      await dispatch(
         getReportOutstandingDetail({
            accIds: id,
            fromDate: '2010-04-01',
            toDate: today,
            companyIds: user?.loginhistory?.companyId,
            isPurchaseOs: 0,
         }),
      );
      await dispatch(getSingleVendors(id));
      if (accountbyid) {
         dispatch(
            getReportLedger({
               fromDate: '2010-04-01',
               toDate: today,
               companyIds: companyId.toString(),
               accIds: accountbyid.id.toString(),
            }),
         );
      }
      setIsOpenSingleView(true);
   };

   const [isDropdownOpen, setDropdownOpen] = useState(false);

   const toggleDropdown = () => {
      setDropdownOpen(!isDropdownOpen);
   };

   const [selectedColumn, setSelectedColumn] = useState(null);
   const [dropdownPosition, setDropdownPosition] = useState({ left: 0, top: 0 });

   const handleImageClick = (columnHeader) => {
      const headerText = selectedColumn?.props?.children;

      const imgElement = document.getElementById(headerText);

      if (imgElement) {
         const rect = imgElement.getBoundingClientRect();
         const dropdownLeft = rect.left + window.scrollX;
         const dropdownTop = rect.bottom + window.scrollY + 5;
         setDropdownPosition({ left: dropdownLeft, top: dropdownTop });
      }
      setSelectedColumn(columnHeader);
      setDropdownOpen(true);

      if (selectedColumn?.props?.children === 'NAME') {
         setSelectedFilter(nameselectedfilter);
         setInputValue(nameinputvalue);
      }
      if (selectedColumn?.props?.children === 'ADDRESS') {
         setInputValue(addressinputvalue);
      }
      if (selectedColumn?.props?.children === 'MOBILE') {
         setInputValue(mobileinputvalue);
      }
      if (selectedColumn?.props?.children === 'CITY') {
         setInputValue(cityinputvalue);
      }
      if (selectedColumn?.props?.children === 'STATE') {
         setInputValue(stateinputvalue);
      }
      if (selectedColumn?.props?.children === 'COUNTRY') {
         setInputValue(countryinputvalue);
      }
      if (selectedColumn?.props?.children === 'PINCODE') {
         setInputValue(pincodeinputvalue);
      }
      if (selectedColumn?.props?.children === 'PAN') {
         setInputValue(paninputvalue);
      }
      if (selectedColumn?.props?.children === 'EMAIL') {
         setInputValue(emailinputvalue);
      }
      if (selectedColumn?.props?.children === 'GST') {
         setInputValue(gstinputvalue);
      }
      if (selectedColumn?.props?.children === 'CREATED DATE') {
         setInputValue(createddateinputvalue);
      }
      if (selectedColumn?.props?.children === 'LEDGER') {
         setInputValue(ledgerinputvalue);
      }
      if (selectedColumn?.props?.children === 'BALANCE') {
         setInputValue(balanceinputvalue);
      }
   };

   const handleFilterClick = () => {
      const selectedKey = selectedColumn?.props?.children;

      const inputSetters = {
         NAME: setnameinputvalue,
         ADDRESS: setaddressinputvalue,
         CITY: setcityinputvalue,
         STATE: setstateinputvalue,
         COUNTRY: setcountryinputvalue,
         PINCODE: setpincodeinputvalue,
         MOBILE: setmobileinputvalue,
         PAN: setpaninputvalue,
         EMAIL: setemailinputvalue,
         GST: setgstinputvalue,
         'CREATED DATE': setcreateddateinputvalue,
         LEDGER: setledgerinputvalue,
         BALANCE: setbalanceinputvalue,
      };

      const selectedoption = {
         NAME: setnameselectedfilter,
         ADDRESS: setAddressSelectedFilter,
         CITY: setCitySelectedFilter,
         STATE: setStateSelectedFilter,
         COUNTRY: setCountrySelectedFilter,
         PINCODE: setPincodeSelectedFilter,
         MOBILE: setmobileselectedfilter,
         PAN: setpanselectedfilter,
         EMAIL: setEmailSelectedFilter,
         GST: setGstSelectedFilter,
         'CREATED DATE': setcreatedDateSelectedFilter,
         LEDGER: setLedgerSelectedFilter,
         BALANCE: setBalanceSelectedFilter,
      };

      if (selectedKey && inputSetters[selectedKey]) {
         inputSetters[selectedKey](inputValue);
      }

      if (selectedKey && selectedoption[selectedKey]) {
         selectedoption[selectedKey](selectedFilter);
      }
      setDropdownOpen(false);
   };

   const [inputValues, setInputValues] = useState({
      NAME: '',
      ADDRESS: '',
      CITY: '',
      STATE: '',
      COUNTRY: '',
      PINCODE: '',
      MOBILE: '',
      PAN: '',
      EMAIL: '',
      GST: '',
      'CREATED DATE': '',
      LEDGER: '',
      BALANCE: '',
   });

   const handleInputChange = (column, value) => {
      setInputValues((prev) => ({
         ...prev,
         [column]: value,
      }));
   };

   const handlecancelClick = () => {
      if (selectedColumn?.props?.children === 'NAME') {
         setnameinputvalue('');
      } else if (selectedColumn.props.children === 'ADDRESS') {
         setaddressinputvalue('');
      } else if (selectedColumn?.props?.children === 'MOBILE') {
         setmobileinputvalue('');
      } else if (selectedColumn.props.children === 'CITY') {
         setcityinputvalue('');
      } else if (selectedColumn.props.children === 'STATE') {
         setstatusinputvalue('');
      } else if (selectedColumn.props.children === 'COUNTRY') {
         setcountryinputvalue('');
      } else if (selectedColumn.props.children === 'PINCODE') {
         setpincodeinputvalue('');
      } else if (selectedColumn.props.children === 'PAN') {
         setpaninputvalue('');
      } else if (selectedColumn.props.children === 'EMAIL') {
         setemailinputvalue('');
      } else if (selectedColumn.props.children === 'GST') {
         setgstinputvalue('');
      } else if (selectedColumn.props.children === 'CREATED DATE') {
         setcreateddateinputvalue('');
      } else if (selectedColumn.props.children === 'LEDGER') {
         setledgerinputvalue('');
      } else if (selectedColumn.props.children === 'BALANCE') {
         setbalanceinputvalue('');
      }
      setDropdownOpen(false);
   };

   const getLeftValue = (column) => {
      switch (column) {
         case 'NAME':
         case 'ADDRESS':
         case 'CITY':
         case 'STATE':
            return '3%';
         case 'COUNTRY':
         case 'PINCODE':
            return '30%';
         case 'MOBILE':
            return '40%';
         case 'ADDRESS':
         case 'CREATED DATE':
            return '60%';
         default:
            return '60%';
      }
   };

   const targetGlGroup = glgroup.find((group) => group.code === 'K');

   const [expanded, setExpanded] = useState(false);
   const wrapperRef = useRef();
   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' ||
            activeElement?.isContentEditable;

         if (isTyping) return;

         if (e.key.toLowerCase() === 'n' || e.key === '+') {
            if (!isOpen && !isOpenSingleView && (Admin || customerRight?.add)) {
               e.preventDefault();
               setCurrentRow({});
               setIsEditMode(false);
               onOpen();
            }
         }
      };

      window.addEventListener('keydown', handleKeyDown);

      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [!isOpen, !isOpenSingleView, Admin, customerRight?.add]);

   return (
      <>
         <Box bg={backgroundColor} w="100%">
            <Flex
               width={{ base: '100%', md: 'auto' }}
               px={{ base: '1px', md: '20px' }}
               justifyContent="space-between"
               align="center"
               overflowX="auto"
               flexWrap="nowrap"
               gap={3}>
               <Flex align="center" gap={4} flexShrink={0}>
                  <Text
                     color={textColor}
                     ml={{ base: '8px', md: 0 }}
                     fontSize={{ base: '15px', lg: '22px' }}
                     fontWeight="700"
                     lineHeight="100%">
                     Customers
                  </Text>
               </Flex>

               <Flex align="center" gap={2} flexShrink={0} p={3}>
                  {!isMobileOrTablet && (Admin || customerRight?.add) && user && !user.isExpired && (
                     <button
                        onClick={() => {
                           setCurrentRow({});
                           setIsEditMode(false);
                           onOpen();
                        }}
                        className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${
                           isDark
                              ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                              : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                        }`}>
                        <span
                           className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${
                              isDark ? 'via-cyan-100/20' : 'via-white/30'
                           }`}></span>

                        <span
                           className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${
                              isDark
                                 ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30'
                                 : 'bg-white/20 group-hover:bg-white/30'
                           }`}>
                           <svg
                              className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                           </svg>
                        </span>

                        <span className="relative text-base font-semibold">Add New</span>
                     </button>
                  )}

                  <IconButton
                     colorScheme="gray"
                     icon={<BsEye />}
                     size="md"
                     mr={1}
                     onClick={() => setIsColumnModalOpen(true)}
                  />

                  <MotionFlex
                     ref={wrapperRef}
                     align="center"
                     bg={bg}
                     borderRadius="full"
                     cursor="pointer"
                     px={expanded ? 3 : 0}
                     w={expanded ? '200px' : '40px'}
                     h="40px"
                     transition="all 0.3s ease"
                     onClick={() => setExpanded(true)}>
                     <MotionSearchIcon
                        color={icon}
                        animate={{ rotate: expanded ? 0 : 90 }}
                        transition={{ duration: 0.3 }}
                        style={{
                           marginRight: expanded ? '8px' : '10px',
                           marginLeft: expanded ? '0' : '10px',
                        }}
                     />
                     {expanded && (
                        <Input
                           variant="unstyled"
                           placeholder="Search..."
                           color={icon}
                           value={searchQuery}
                           onChange={handleSearchChange}
                           autoFocus
                        />
                     )}
                  </MotionFlex>
               </Flex>
            </Flex>

            {isMobileOrTablet && (Admin || customerRight?.add) && user && !user.isExpired && (
               <button
                  onClick={() => {
                     setCurrentRow({});
                     setIsEditMode(false);
                     onOpen();
                  }}
                  className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${
                     isDark
                        ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                        : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                  }`}>
                  <span
                     className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${
                        isDark ? 'via-cyan-100/20' : 'via-white/30'
                     }`}></span>

                  <span
                     className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${
                        isDark ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30' : 'bg-white/20 group-hover:bg-white/30'
                     }`}>
                     <svg
                        className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                     </svg>
                  </span>

                  <span className="relative text-base font-semibold">Add New</span>
               </button>
            )}

            {/* ✅ SHOW LOADER WHEN DATA IS LOADING */}
            {isLoading ? (
               <Loader />
            ) : (
               <DynamicTable
                  right={customerRight}
                  table={table}
                  data={userData}
                  handleViewSingleData={handleViewSingleData}
                  handleStatusChange={handleStatusUpdate}
                  handleImageClick={handleImageClick}
                  toggleDropdown={toggleDropdown}
                  filter={filter}
                  emptyMessage={'No customers data found'}
                  onEditClick={(row) => {
                     setCurrentRow(row);
                     setIsEditMode(true);
                     onOpen();
                     setIsOpenSingleView(false);
                  }}
                  onDeleteClick={(id) => {
                     handleDeleteClick(id);
                     setIsOpenSingleView(false);
                  }}
                  onMultiDeleteClick={(ids) => {
                     handleMutiDeleteClick(ids);
                  }}
                  canDelete={true}
                  columnVisibility={columnVisibility}
                  columnsData={columnsData}
                  sorting={sorting}
                  limit={limit}
                  setCurrentRow={setCurrentRow}
                  onOpen={onOpen}
                  setIsEditMode={setIsEditMode}
                  setIsOpenSingleView={setIsOpenSingleView}
                  setDeleteDialogOpen={setDeleteDialogOpen}
                  setSelectedRowId={setSelectedRowId}
                  debouncedSearchQuery={debouncedSearchQuery}
               />
            )}

            <AddEditForm
               isOpen={isOpen}
               onClose={onClose}
               isEditMode={isEditMode}
               currentRow={currentRow}
               initialData={currentRow}
               onSave={handleSave}
               parentGlGroup={targetGlGroup?.id}
               handleRefreshData={handleRefreshData}
               formType="Customer"
               isAbs={isAbs}
            />
            <DeleteDialog
               isDeleteDialogOpen={isDeleteDialogOpen}
               setDeleteDialogOpen={setDeleteDialogOpen}
               handleDelete={handleDelete}
               title="Customer"
            />
            <ViewSingleData
               singleEntityRights={customerRight}
               isOpenSingleView={isOpenSingleView}
               onClose={() => setIsOpenSingleView(false)}
               entityType="customer"
               singleEntity={singleEntityWithLedger}
               dynamicArray={dynamicArray}
               onDelete={handleDeleteEntity}
               formType="Customer"
               parentGlGroup={targetGlGroup?.id}
               title="Customer"
               reCall={(id) => handleViewSingleData(id)}
            />
         </Box>
         {isDropdownOpen && selectedColumn?.props?.children && (
            <Box
               position="absolute"
               top="300px"
               left={getLeftValue(selectedColumn?.props?.children)}
               width="auto"
               bg={backgroundColor}
               border="1px solid gray"
               borderRadius="5px"
               boxShadow="md"
               p="2"
               mt="2"
               zIndex="10"
               transition="all 0.2s ease-in-out">
               <Grid templateColumns="repeat(1, 1fr)" gap={4} p={4}>
                  <Grid justifyContent="center" color={textColor} fontSize="2xl" fontWeight="medium">
                     <label>Select {selectedColumn.props.children.toLowerCase()} Filter</label>
                  </Grid>
                  <hr></hr>
                  {['CREATED DATE', 'BALANCE', 'GST PERCENTAGE', 'HSN', 'ORDINAL', 'ACCOUNT NO'].includes(
                     selectedColumn?.props?.children,
                  ) ? (
                     <GridItem display="flex" alignItems="center">
                        <FormLabel htmlFor="dropdown" width="60%" color={textColor}>
                           Select option
                        </FormLabel>
                        <Select
                           id="dropdown"
                           placeholder="Choose an option"
                           color={textColor}
                           onChange={(e) => setSelectedFilter(e.target.value)}>
                           <option value="equal">Equal (=)</option>
                           <option value="less_than">Less than (&lt;)</option>
                           <option value="less_than_equal">Less than or equal (&le;)</option>
                           <option value="greater_than">Greater than (&gt;)</option>
                           <option value="greater_than_equal">Greater than or equal (&le;)</option>
                        </Select>
                     </GridItem>
                  ) : (
                     <GridItem display="flex" alignItems="center">
                        <FormLabel htmlFor="dropdown" width="60%" color={textColor}>
                           Select option
                        </FormLabel>
                        <Select
                           id="dropdown"
                           placeholder="Choose an option"
                           color={textColor}
                           onChange={(e) => setSelectedFilter(Number(e.target.value))}>
                           <option value={1}>Starts With</option>
                           <option value={2}>Ends With</option>
                           <option value={3}>Contains</option>
                           <option value={4}>Equal</option>
                           <option value={5}>Empty</option>
                           <option value={6}>Does Not Start With</option>
                           <option value={7}>Does Not End With</option>
                           <option value={8}>Does Not Contain</option>
                           <option value={9}>Not Equal</option>
                           <option value={10}>Not Empty</option>
                           <option value={11}>Like</option>
                        </Select>
                     </GridItem>
                  )}

                  {selectedColumn?.props?.children === 'CREATED DATE' ? (
                     <GridItem display="flex" alignItems="center">
                        <FormLabel htmlFor="input1" width="60%" color={textColor}>
                           Select Date
                        </FormLabel>
                        <Input
                           type="date"
                           border="1px solid"
                           value={createddateinputvalue}
                           onChange={(e) => setcreateddateinputvalue(e.target.value)}
                        />
                     </GridItem>
                  ) : (
                     <GridItem display="flex" alignItems="center">
                        <FormLabel htmlFor="input1" width="60%" color={textColor}>
                           Enter the value
                        </FormLabel>
                        <Input
                           id="input2"
                           color={textColor}
                           placeholder="enter value"
                           value={inputValue}
                           onChange={(e) => setInputValue(e.target.value)}
                        />
                     </GridItem>
                  )}
                  <GridItem mt="20px" display="flex" justifyContent="space-between">
                     <Button colorScheme="blue" width="45%" onClick={handleFilterClick}>
                        Filter
                     </Button>
                     <Button colorScheme="red" width="45%" onClick={handlecancelClick}>
                        cancel
                     </Button>
                  </GridItem>
               </Grid>
            </Box>
         )}
         <ColumnVisibilityModal
            isOpen={isColumnModalOpen}
            onClose={() => setIsColumnModalOpen(false)}
            columnVisibility={columnVisibility}
            setColumnVisibility={setColumnVisibility}
            user={user}
         />
      </>
   );
}
